import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { InterviewStudentApi } from "../../../api/interview-student/interview-student.api";
import _ from "lodash";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../history-online-Admission/enum/admission.enum";
import { dateToView } from "../../../utils/date.utils";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");
    const [remark, set_remark] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [formInterview, setFormInterview] = useState<any[]>([]);

    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [form, set_form] = useState<any>()
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");
    const handleCloseModal = () => {
        setShowModal("");
        set_form(null)
        setFormInterview([])
        set_remark('')
        setIsCheckAll('')
        setIsChecks([])
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const [isChecks, setIsChecks] = useState<any[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<string>("");
    const onCheck = (event: any) => {
        const { checked, value } = event;
        if (checked) {
            setIsChecks((prev) => [...prev, Number(value)]);
            setFormInterview((prev: any) => [...prev, data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS")?.find((item: any) => item?.id_admission_student === Number(value))])

        } else {
            setIsChecks((prev) => prev.filter((x) => x !== Number(value)));
            setFormInterview((prev: any) => [...prev, data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS")?.find((item: any) => item?.id_admission_student === Number(value))])


        }
    };

    const onCheckAll = (event: any) => {
        const { checked } = event;
        const id = data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS")?.map(
            (filteredItem: { id_admission_student: number }) => filteredItem?.id_admission_student
        );
        if (checked) {
            setIsChecks(Array.from(new Set([...isChecks, ...id])));
            setFormInterview(Array.from(new Set([...data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS"), ...formInterview])))

        } else {
            setIsChecks([]);
            setFormInterview([]);
            // setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)));
        }
    };
    const handleOnCheckAll = () => {
        const hasSome = _.some(data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS"), (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_admission_student) === Number(j))
        );
        const hasAll = _.every(data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS"), (i: any) =>
            _.some(isChecks, (j: number) => Number(i?.id_admission_student) === Number(j))
        );
        if (!_.isEmpty(isChecks) && !hasAll && hasSome)
            setIsCheckAll("indeterminate");
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll("checked");
        else setIsCheckAll("");
    };
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    useEffect(() => {
        handleOnCheckAll();
    }, [isChecks]);

    const headCells = [
        {
            id: "id_admission_student",
            disablePadding: false,
            label: "CHECKBOX",
            align: "end",
            // disabled: view
            values: [],
            indeterminate: isCheckAll === "indeterminate" && true,
            checked: isCheckAll === "checked" && true,
            disableDropdown: true,
            hiddenDropdown: true,
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: 50,
            sortable: false,
        },
        {
            id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'left', label: t("INTERVIEW_STUDENT_FULL_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("INTERVIEW_STUDENT_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("INTERVIEW_STUDENT_LEVEL")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("INTERVIEW_STUDENT_COURSE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("INTERVIEW_STUDENT_APPLY_DATE")
        },
        // {
        //     id: "status", disablePadding: false, align: "center", width: 141, label: t("การชำระเงิน")
        // },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("INTERVIEW_STUDENT_STATUS")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            first_name,
            last_name,
            middle_name,
            degree_name,
            faculty_name,
            interview_student_date,
            admission_status,
            id_admission_student

        } = objData;
        const rowCheck = _.some(
            isChecks,
            (i: number) => Number(i) === Number(id_admission_student)
        );
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                {
                    option: "CHECKBOX",
                    align: "center",
                    label: id_admission_student,
                    disabled: admission_status === "INTERVIEW_SUCCESS"
                },
                { option: "TEXT", align: "left", label: `${first_name} ${last_name}` || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: middle_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: interview_student_date ? dateToView(interview_student_date) : "-"
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: create_name || "-",
                // },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(admission_status)}
                        type={renderStatus(admission_status)}
                    />,
                },


                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <IconButton onClick={() => navigate(routeName.admission.interview_student_detail.replace(':id', `${id_admission_student}`))}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
            onCheck={(event) => onCheck(event.target)}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        if (status !== "ALL") query = { ...query, interview_student_result: status }
        dispatch(setLoading());
        await InterviewStudentApi.getInterviewStudentList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate, id_degree, id_faculty])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])
    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getDegree()
        getFaculty()
    }, [])
    const handleSubmit = async () => {
        const body = isChecks?.map((item: any) => {
            return {
                ...form,
                interview_student_date: `${form?.interview_student_date}T${form?.interview_student_time}`,
                id_admission_student: item
            }
        })
        dispatch(setLoading());
        await InterviewStudentApi.createInterviewStudent(body)
            .then((res) => {
                if (res.status < 300) {
                    setShowModal('')
                    alertSuccess(t('INTERVIEW_STUDENT_INTERVIEW_INFO'), t('INTERVIEW_STUDENT_INTERVIEW_INFO_COMPLETED'));
                    handleGetData()
                    // navigate(routeName.admission.ManagePayment)
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t('INTERVIEW_STUDENT_INTERVIEW_INFO'), t('INTERVIEW_STUDENT_INTERVIEW_INFO_FAILED'));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }

    const handleAPPROVE = async (status: string,) => {
        const body = formInterview?.map((item: any) => {
            return {
                id_admission_student: item?.id_admission_student,
                id_interview_student: item?.id_interview_student,
                interview_student_result: status,
                interview_student_result_remark: remark
            }
        })
        dispatch(setLoading());
        if (body?.length > 0) {
            await InterviewStudentApi.resultInterview(body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("INTERVIEW_STUDENT_REVIEW"), t("INTERVIEW_STUDENT_REVIEW_COMPLETED"));
                        handleGetData()
                        handleCloseModal()
                        // navigate(routeName.admission.ManagePayment)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("INTERVIEW_STUDENT_REVIEW"), t("INTERVIEW_STUDENT_REVIEW_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmit,
        setShowModal,
        handleAPPROVE,
        remark,
        set_remark,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        status,
        set_status
    }
}

export default ManageState